<template>
  <div class="isolate inline-flex rounded-md shadow-sm">
    <button
      type="button"
      @click="decreaseZoom"
      :class="`app-button--text--${rsCollection?.config?.theme}`"
      class="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-lg font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
    >
      <i class="mdi mdi-minus-box" />
    </button>
    <button
      type="button"
      @click="increaseZoom"
      :class="`app-button--text--${rsCollection?.config?.theme}`"
      class="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-lg font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
    >
      <i class="mdi mdi-plus-box" />
    </button>
    <button
      v-if="rsCollection?.config?.download && !hideOnSites"
      type="button"
      @click="quickDownload()"
      :class="`app-button--text--${rsCollection?.config?.theme}`"
      class="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-lg font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
    >
      <i class="mdi mdi-download-box" />
    </button>
    <BaseTooltip
      :tip="tagMode === 'showtags' ? $t('Hide Tags') : $t('Show tags')"
    >
      <template v-slot:content>
        <button
          type="button"
          @click="toggleTagVisibility()"
          :class="[`app-button--text--${rsCollection?.config?.theme}`]"
          class="h-10 w-11 relative -ml-px inline-flex items-center bg-white px-3 py-2 text-lg font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
        >
          <i
            class="mdi"
            :class="{
              'mdi-tag': tagMode === 'hidetags', // show inverted icon
              'mdi-tag-off': tagMode === 'showtags',
            }"
          ></i>
        </button>
      </template>
    </BaseTooltip>

    <BaseTooltip
      :tip="
        textOverlayVisible ? $t('Hide text overlay') : $t('Show text overlay')
      "
    >
      <template v-slot:content>
        <button
          type="button"
          @click="toggleTextOverlay()"
          :class="[
            `app-button--text--${rsCollection?.config?.theme}`,
            { 'rounded-r-md': !$slots['custom-buttons'] },
          ]"
          class="h-10 w-11 relative -ml-px inline-flex items-center bg-white px-3 py-2 text-lg font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
        >
          <span class="material-symbols-outlined">
            {{ textOverlayVisible ? 'preview_off' : 'preview' }}
          </span>
        </button>
      </template>
    </BaseTooltip>
    <slot name="custom-buttons"></slot>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import { useSiteStore } from '~/stores/sites'

import MetadataModal from '~/components/Sites/MetadataModal.vue'

export default {
  setup() {
    const sitesApi = useSites()
    const sitesStore = useSiteStore()
    const imageComp = useImageComp()
    const runtimeConfig = useRuntimeConfig()

    return {
      sitesStore,
      sitesApi,
      imageComp,
      runtimeConfig,
    }
  },
  data() {
    return {
      textOverlayVisible: false,
      tagMode: 'showtags',
    }
  },
  props: {
    /*     displayMode: {
      type: String,
      required: true,
    }, */
    imageKey: {
      type: String,
    },
    xmlKey: {
      type: String,
    },
    showTextVisibilityToggle: {
      type: Boolean,
      default: true,
    },
    hideOnSites: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useSiteStore, ['language', 'rsCollection']),
  },
  methods: {
    applyOverlay() {
      this.textOverlayVisible
        ? this.$emit('buttonClick', 'showTextOnImage')
        : this.$emit('buttonClick', 'hideTextOnImage')
    },
    toggleTextOverlay() {
      this.textOverlayVisible = !this.textOverlayVisible
      this.applyOverlay()
    },
    toggleTagVisibility() {
      if (this.tagMode === 'showtags') {
        this.$emit('buttonClick', 'hidetags')
        this.tagMode = 'hidetags'
      } else {
        this.$emit('buttonClick', 'showtags')
        this.tagMode = 'showtags'
      }
      //Settings.instance().toggleHideAll()
      console.log('CLICK', this.tagMode)
    },
    // ...mapActions(['toggleTextVisibility']),
    /*     setDisplayMode(value) {
      this.$bus.emit('SET_DISPLAY_MODE', value)
      this.$emit('input', { type: 'display', value })
    }, */
    setTagMode(value) {
      this.$bus.emit('SET_TAG_MODE', value)
      this.$emit('input', { type: 'tag', value })
    },
    increaseZoom() {
      this.$bus.emit('INCREASE_ZOOM')
      this.$emit('buttonClick', 'zoomIn')
    },
    decreaseZoom() {
      this.$bus.emit('DECREASE_ZOOM')
      this.$emit('buttonClick', 'zoomOut')
    },
    showMetadata() {
      const modal = {
        modalContent: {
          component: MetadataModal,
          props: {
            metadata: this.metaData,
          },
        },
      }
      this.$bus.emit('open-modal', { modal: modal })
    },
    async quickDownload() {
      const imageKey = this.imageKey

      const xmlkey = this.xmlKey

      // Download image
      const imageResponse = await fetch(this.imageComp.getImageSource(imageKey))
      const imageBlob = await imageResponse.blob()
      const imageURL = URL.createObjectURL(imageBlob)
      const imglink = document.createElement('a')
      imglink.href = imageURL
      imglink.download = `${imageKey}.jpg`
      imglink.click()

      // Download txt
      const container = document.getElementById('textContainer')
      const text = container?.innerText
      const blob = new Blob([text], { type: 'text/plain' })
      const txtURL = URL.createObjectURL(blob)
      const txtlink = document.createElement('a')
      txtlink.href = txtURL
      txtlink.download = `${xmlkey}.txt`
      txtlink.click()
    },
  },
}
</script>
